import { Component, Input, OnInit } from "@angular/core";
import { TutorialVideoModalService } from "src/app/shared/services/tutorial-video-modal.service";

@Component({
  selector: 'widget-content-2',
  templateUrl: './widget-content-2.component.html',
  styleUrls: ['./widget-content-2.component.scss']
})
export class WidgetContent2Component implements OnInit {
  @Input() widgetConfig;
  settings: any = {};

  constructor(private tutorialModalService: TutorialVideoModalService) {}

  ngOnInit() {
    this.settings = this.widgetConfig.widgetSettings;
  }

  openVideo() {
    this.tutorialModalService.openTutorialModal(
      "Video",
      "",
      this.settings.buttonUrl,
      "Close",
      "800px"
    );
  }
}
